<template>
  <div class="accordion" role="tablist" :key="sidemenuKey" v-if="renderList">
    <div @click="allProjects()" role="button" class="list-title list-projects" :class="[mainProjectClass(), (projectAccordion) ? 'not-collapsed' : 'collapsed']">
      <div class="d-block">{{ $gettext('Active projects') }}</div>
      <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
      <div class="listitem--time">{{ assignedActiveProjectsHours }}
        <span v-if="totalUnassignedHours" class="inline">
          <span class="mx-2">|</span> <span class="text-unassigned">{{ totalUnassignedHours }} {{ $gettext('unassigned') }}</span>
        </span>
      </div>
    </div>
      <b-collapse id="projects_collapse" v-model="projectAccordion" accordion="hour_project_customer_sidemenu_accordion" role="tabpanel">
        <b-row class="accordion--actions">
          <b-col class="col-12 listitem--add text-center">
            <div role="button" @click="$emit('open-project-modal-mini', false)"><font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add new project') }}</div>
          </b-col>
        </b-row>
        <b-card-body class="p-0">
          
          <overlay-scrollbars ref="actListOs" :options="scrollbarOptions">
            <div v-for="a_project in fullProjectsList" :key="'p_' + a_project.id" class="item-wrap">
              <div class="starbtn-favorite" :class="[(a_project.favorite) ? 'favorite' : 'not-favorite']" role="button" @click="toggleFavorite(a_project)">
                <font-awesome-icon aria-hidden="true" :icon="(a_project.favorite) ? 'fa-solid fa-star' : 'fa-regular fa-star'" />
              </div>
              <div @click="selectProject(a_project, 'projects')" :class="[projectClass(a_project.id)]" class="listitem listitem--project">
                <b-row>
                  <b-col class="listitem--name">{{ a_project.name }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="col-7 listitem--subname">{{ a_project.customer_name }}</b-col>
                  <b-col class="col-5 listitem--time d-flex justify-content-end">
                    <div class="listitem--time--amount">{{ (projectHours[a_project.id]) ? projectHours[a_project.id].total : '' }}</div>
                  </b-col>
                </b-row>
              </div>
            </div>

          </overlay-scrollbars>

        </b-card-body>
      </b-collapse>
    <hr>
    <div class="list-title list-customer" v-b-toggle.customer_collapse variant="info">
      {{ $gettext('Customers') }}
      <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
    </div>
    <b-collapse :visible="isExpandedMain()" id="customer_collapse" accordion="hour_project_customer_sidemenu_accordion" role="tabpanel">
      <b-row class="accordion--actions">
        <b-col class="col-6 search pr-0">
          <b-form-input id="type-search" size="sm" :placeholder="$gettext('Search...')" type="search" v-model="search.filters.search_by_name" />
        </b-col>
        <b-col class="col-6 listitem--add">
          <div role="button" @click="$emit('open-contact-modal', false)"><font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add new') }}</div>
        </b-col>
      </b-row>
      
      <b-card-body class="p-0">

        <overlay-scrollbars ref="custListOs" :options="scrollbarOptions">

          <div v-for="a_customer in filteredCustomers" :key="'c_' + a_customer.id" class="sublist-wrap">
            <div @click="selectCustomer(a_customer, 'customers')" class="sublist-title" :class="[clientClass(a_customer.id)]">
              <b-row>
                <b-col class="col listitem--name">{{ a_customer.name }}</b-col>
              </b-row>
              <b-row>
                <b-col class="listitem--time d-flex">
                  <div class="listitem--time--amount">{{ (companyHours[a_customer.id]) ? companyHours[a_customer.id].total : '' }}</div>
                </b-col>
              </b-row>
              <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
            </div>
            <b-collapse :visible="isExpanded(a_customer)" :id="'customer_project_collapse_'+a_customer.id" :accordion="'hour_customer_project_sidemenu_accordion'" role="tabpanel">
              <div v-for="a_project in a_customer.projects" :key="'c_p_' + a_customer.id + '_' + a_project.id" @click="selectProject(a_project, 'customers')" :class="projectClass(a_project.id)" class="item-wrap listitem">
                <div class="starbtn-favorite" :class="[(a_project.favorite) ? 'favorite' : 'not-favorite']" role="button" @click="toggleFavorite(a_project)">
                  <font-awesome-icon aria-hidden="true" :icon="(a_project.favorite) ? 'fa-solid fa-star' : 'fa-regular fa-star'" />
                </div>
                <b-row>
                  <b-col class="listitem--name">{{ a_project.name }}</b-col>
                </b-row>
                <b-row>
                  <b-col class="listitem--time d-flex">
                    <div class="listitem--time--amount">{{ (projectHours[a_project.id]) ? projectHours[a_project.id].total : '' }}</div>
                  </b-col>
                </b-row>
              </div>
              <div class="listitem listitem--actions">
                <b-row>
                  <div class="col listitem--add" @click="$emit('open-project-modal', a_customer.id)" role="button">
                    <font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add project') }}
                  </div>
                </b-row>
              </div>
            </b-collapse>
          </div>

        </overlay-scrollbars>

      </b-card-body>
    </b-collapse>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';

  import CustomerService from "@/store/services/customer.service.js";
  import HourService from "@/store/services/hour.service.js";
  import ProjectService from "@/store/services/project.service";

  export default {
    name: "HourCustomerSidemenu",
    components: { },
    props: {
      mutationName: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        hourText: this.$gettext('h'),
        minuteText: this.$gettext('m'),
        sidemenuKey: 0,
        customerSearch: '',
        customerList: [],
        projectListFav: [],
        projectListFavAll: [],
        projectListActive: [],
        customerFilters: {
          owner_company: null,
          is_customer: "True",
          extended: "True",
          is_archived: "False",
          remove_archived_projects: "True"
        },
        totalHourFilter: {},
        companyHours: {},
        projectHours: {},
        selected: null,
        selectedCustomer: null,
        projectAccordion: true,
        unassignedAccordion: false,
        renderList: false,
        search: {
          filters: { 
            extended: true,
            contains_project: 'True',
            search_by_name: ''
          },
          debounce: 500,
          count: 0,
          next: false,
          hint: true,
          more: false,
          active: false
        },
        scrollbarOptions: {
          scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' }
        }
      }
    },
    computed: {
      ...mapGetters({ 
        getCompanyId: 'main/getCompanyId'
      }),
      filteredCustomers () {
        // Finding customers
        const notArchivedCustomers = this.customerList.filter( a_customer => !a_customer.is_archived );
        const searchCustomers = notArchivedCustomers.filter( a_customer => a_customer.name.toLocaleLowerCase().includes(this.search.filters.search_by_name.toLocaleLowerCase()) );

        // Finding projects
        notArchivedCustomers.forEach(customer => {
          const found = customer.projects.filter(project => project.name.toLocaleLowerCase().includes(this.search.filters.search_by_name.toLocaleLowerCase()));
          if (found.length > 0 && !searchCustomers.find(item => item.id === customer.id)) searchCustomers.push(customer)
        })

        return (this.search.filters.search_by_name) ? searchCustomers : notArchivedCustomers
      },
      partialProjectsList () {
        return this.projectListFav.concat(this.projectListActive)
      },
      projectListRecent () {
        const allProjects = this.customerList.map(customer => customer.projects).flat()
        let recentProjects = []
        allProjects.forEach(recent => {
          if (!this.partialProjectsList.find(project => project.id === recent.id) && this.hasRecentUse(recent.last_used)) {
            recent.customer_name = this.customerList.find(customer => customer.id === recent.company).name
            recentProjects.push(recent)
          }
        })
        recentProjects.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

        return recentProjects
      },
      fullProjectsList () {
        return this.partialProjectsList.concat(this.projectListRecent)
      },
      assignedActiveProjectsHours () {
        let totalAmount = 0
        this.fullProjectsList.forEach(project => {
          if (this.projectHours[project.id]) {
            totalAmount += this.projectHours[project.id].total_raw
          }
        })
        // if (this.projectHours[null]) {
        //   totalAmount += this.projectHours[null].total_raw
        // }
        return this.formatAmount(totalAmount)
      },
      totalUnassignedHours () {
        let totalAmount = 0
        if (this.projectHours[null]) {
          totalAmount += this.projectHours[null].total_raw
        }
        return (totalAmount > 0) ? this.formatAmount(totalAmount) : false
      }
    },
    created () {
      this.customerFilters.owner_company = this.getCompanyId
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === this.mutationName && state["hourStore"].notRefreshComponent !== this.$options.name) {
          if(state["hourStore"].refreshComponent === this.$options.name) {
            this.projectListActive = []
            this.projectListFav = []
            this.projectListFavAll = []
            this.sidemenuKey++
            this.getCustomerList(true)
          } else {
            this.filters = state["filterStore"].filter
            this.getTotals(this.filters)
          }
        }
      });
      this.getCustomerList(true);
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      toggleFavorite (project) {
        project.favorite = !project.favorite;
        ProjectService.update(project.id, project).then(() => {
          this.sidemenuKey++
          this.getCustomerList(true)
        })
      },
      formatAmount (amount) {
        return Math.floor(amount) + this.hourText + ' ' + Math.round((amount - Math.floor(amount)) * 60) + this.minuteText
      },
      getCustomerList (firstTime) {
        CustomerService.list(this.customerFilters).then((response) => {
          this.projectListFavAll = []

          this.customerList = response.data;

          this.customerList.forEach((a_customer) => {
            a_customer.projects.forEach((a_project) => {
              if(a_project.favorite){
                a_project.customer_name = a_customer.name;
                this.projectListFavAll.push(a_project);
              }
            })
          })
          
          if (firstTime) {
            this.filters = this.$store.getters["filterStore/getFilter"] || {};
            if(this.filters.activeView){
              this.getTotals(this.filters, firstTime);
            }
          }
        })
      },
      updateAmounts (filter) {
        this.getTotals(filter);
      },
      getTotals (filter, firstTime) {
        var hourFilters = {};

        if(this.$store.getters["filterStore/getFilter"].created_by) {
          hourFilters.created_by = this.$store.getters["filterStore/getFilter"].created_by;
        }

        hourFilters.company_profile = this.getCompanyId;
        hourFilters.start_date = filter.start_date;
        hourFilters.end_date = filter.end_date;

        hourFilters.group_by = 'project,project__company_id';
        HourService.getTotalAmount(hourFilters).then((response) => {
          this.projectHours = {}
          this.companyHours = {}
          var projectIds = []

          // Get unique company ids with hours
          const companyIds = [...new Set(response.data.map(project => project.project__company_id))] 

          // Initialize company hours array
          companyIds.forEach(item_id => {
            this.companyHours[item_id] = { total: 0, uninvoiced: 0 }
          });

          // Format all project hours amount 
          // get unique project ids and calculate company amounts
          response.data.forEach((item) => {
            this.projectHours[item.project] = { total: this.formatAmount(item.total), uninvoiced: this.formatAmount(item.uninvoiced), total_raw: item.total }
            projectIds.push(item.project);
            this.companyHours[item.project__company_id].total += item.total
            this.companyHours[item.project__company_id].uninvoiced += item.uninvoiced
          });

          // Format all company hours amount 
          Object.keys(this.companyHours).forEach(company => {
            this.companyHours[company].total = this.formatAmount(this.companyHours[company].total)
            this.companyHours[company].uninvoiced = this.formatAmount(this.companyHours[company].uninvoiced)
          })

          this.renderList = true
          this.projectListActive = []
          this.projectListFav = this.projectListFavAll // resetting favorite projects

          this.projectListFav = this.projectListFav.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

          this.customerList.forEach((a_customer) => {
            a_customer.projects.forEach((a_project) => {
              if (projectIds.includes(a_project.id)) {
                a_project.customer_name = a_customer.name;
                if (!a_project.favorite) this.projectListActive.push(a_project)
              }
            })
          })

          this.projectListActive.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

          if (firstTime) {
            this.scrollToElement()
          }
          if(firstTime && this.filters.project){
            this.selected = this.filters.project;
            // get full project and emit to show Invoice Hours button
            // but dont refresh everything -> firstTime = true
            const fullproject = this.fullProjectsList.find(x => x.id === this.selected);
            this.$emit('change', { project: fullproject, firstTime: true })
          } else {
            // set selected to null if project is not on any project list
            // and emit change with firsTime just to hide Invoice Hours button
            const fullproject = this.fullProjectsList.find(x => x.id === this.selected);
            if (!fullproject) {
              this.selected = null
              this.$emit('change', { project: fullproject, firstTime: true })
            }
          }
        })
      },
      scrollToElement () {
        let scrollPerItem = 52.5
        let scrollPerItemCusProj = 52.5
        let project_idx = 0
        let customer_idx = 0
        let scrollTargetList = 'actListOs'
        if (this.$store.getters['filterStore/getCurrentProject'] && !this.$store.getters['filterStore/getCurrentCustomer']) {
          // active projects list
          project_idx = this.fullProjectsList.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentProject'])
        }
        if (this.$store.getters['filterStore/getCurrentCustomer']) {
          // customers list
          customer_idx = this.filteredCustomers.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentCustomer'])
          if (this.$store.getters['filterStore/getCurrentProject'] && customer_idx in this.filteredCustomers) {
            project_idx = this.filteredCustomers[customer_idx].projects.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentProject'])
          }
          scrollPerItem = 47.5
          scrollTargetList = 'custListOs'
        }
        setTimeout(() => {
          if (this.$refs[scrollTargetList]) {
            const osInstance = this.$refs[scrollTargetList].osInstance();
            osInstance.scrollStop().scroll({
              y: (customer_idx * scrollPerItem) + (project_idx * scrollPerItemCusProj)
            });
          }
        }, 200);
      },
      selectProject (project, list){
        this.selected = project.id;
        this.$emit('change', { project: project, list: list })
      },
      selectCustomer (customer, list){
        this.$emit('select-customer', { customer: customer, list: list })
      },
      unassignedMenuClass () {
        if(this.$store.getters['filterStore/getUnassigned']) {
          return 'selected';
        }
        return '';
      },
      mainProjectClass () {
        if(!this.$store.getters['filterStore/getUnassigned'] && !this.$store.getters['filterStore/getCurrentProject'] && !this.$store.getters['filterStore/getCurrentCustomer']){
          return 'selected';
        }
        return '';
      },
      projectClass (project_id){
        if(project_id === this.$store.getters['filterStore/getCurrentProject']){
          return 'selected';
        }
        return '';
      },
      clientClass (client_id) {
        if(client_id === this.$store.getters['filterStore/getCurrentCustomer'] && !this.$store.getters['filterStore/getCurrentProject']){
          return 'selected';
        }
        return '';
      },
      unassignedHours () {
        this.selected = null
        this.$emit('change', { unassigned: true })
      },
      allProjects () {
        this.selected = null
        this.$emit('change', { project: null })
        this.projectAccordion = true
      },
      isExpandedMain () {
        let expanded = false
        if((this.$store.getters["filterStore/getCurrentCustomer"] !== null)) {
          this.projectAccordion = false
          expanded = true
        }
        return expanded
      },
      isExpanded (client) {
        return this.$store.getters['filterStore/getCurrentCustomer'] === client.id
      },
      hasRecentUse (date) {
        const period = 30 // days
        const lastUsed = new Date(date)
        const lastPeriod = new Date()
        lastPeriod.setDate(lastPeriod.getDate() - period);
        return lastUsed.getTime() > lastPeriod.getTime()
      }
    }
  };
</script>
<style lang="scss">
  .calendar-sidemenu {
    small { 
      line-height: 1rem;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #6b7280;
      margin-bottom: 5px;
      width: 100%;
      display: block;
    }
  }
  
  .calendar-sidemenu {
    .accordion {
      height: 100%;
      .collapse { overflow: hidden; }
      .card-body { box-shadow: inset 0px 6px 10px -10px #e9e9e9; }
      .os-host { max-height: 500px; }
      .os-scrollbar { width: 0.5rem !important; border-radius: $radiusLg !important; }
      .os-content { padding: 1px 7px 1px 1px !important; } // for selected shadow
    }
  }

  /* new auto height scrolling */
  @media(min-width: '768px') {
    .calendar-sidemenu {
      .accordion {
        display: flex;
        flex-direction: column;
        #customer_collapse {
          height: 100%;
          .card-body {
            height: 100%;
          }
          .os-host { 
            max-height: initial;
            height: calc(100% - 50px); // 100% - accordion-actions height
          }
        }
      }
    }
  }

  /* dbug */
  // .calendar-sidemenu {
  //   outline: 1px solid black;
  //   background: red;
  //   .accordion {
  //     background: blue;
  //     .collapse {
  //       background: lime;
  //       .card-body {
  //         background: green;
  //         .os-host {
  //           background: yellow;
  //         }
  //       }
  //     }
  //   }
  // }

  @media(max-width: '767px') {
    .calendar-sidemenu {
      min-height: auto;
      .collapse {
        max-height: 250px;
        overflow-y: scroll;
        overflow-x: hidden;
        .os-host {
          max-height: 200px;
        }
      }
    }
  }

</style>
<style lang="scss" scoped>
  #projects_collapse .os-host-overflow-y .item-wrap,
  #customer_collapse .os-host-overflow-y .sublist-wrap {
    padding-right: 0.25rem;
  }
  .item-wrap {
    position: relative;
    .starbtn-favorite {
      display: none;
      position: absolute;
      top: 0px;
      right: 10px;
      outline: none;
      border: none;
      background: none;
      padding: 0;
      color: $colorGold;
      font-size: 16px;
      z-index: 10;
      &.favorite {
        display: block;
      }
    }
    &:hover {
      .starbtn-favorite {
        display: block;
      }
    }
  }
  .listitem,
  .sublist-title {
    border-radius: $radiusMd;
    cursor: pointer;
    padding: 5px 7px;
    margin-bottom: 7px;
    // margin-left: 1px;
    position: relative;
    &--name {
      font-size: 16px;
      padding-right: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.2;
    }
    &--subname {
      color: #AFAFAF;
      font-size: 11px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &--time {
      font-family: DINNextLTPro-Regular, sans-serif;
      color: #6C6C6C;
      font-size: 11px;
      height: 12px;
      overflow: hidden;
      transition: height 0.2s ease;
      &--amount {
        width: 45px;
      }
    }
    // &--actions { padding-top: 5px; }
    &--add {
      font-size: 15px;
      color: $colorBlue;
    }
  }

  .listitem:not(.listitem--actions),
  .accordion .sublist-title,
  .accordion .list-title {
    &:hover { background: $colorBlue50; } // #091e4208
    &.selected { 
      background: $colorBlue100;
      box-shadow: $filtersShadow;
    }
  }
  .accordion .sublist-title,
  .accordion .list-title {
    background: transparent;
    outline: none;
  }
   .accordion .list-title {
    background: #f4f4f4; // base unselected bg
  }
  .list-title {
    position: relative;
    font-size: 18px; // 20px
    padding: 10px 7px;
    border-radius: $radiusMd;
    // margin-bottom: 5px;
  }
  .sublist-title {
    position: relative;
    .listitem--name {
      font-size: 16px; // 17px
    }
  }
  .list-title, .sublist-title {
    font-family: DINNextLTPro-Medium, sans-serif;
    line-height: 1.2;
    .list-caret {
      color: $colorBlue;
      font-size: 14px;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      transition: transform 0.2s ease; 
    }
  }
  .sublist-title {
    .list-caret {
      opacity: 0.5;
      font-size: 12px;
    }
  }
  .list-title {
    &.list-customer {
      padding: 16px 7px; // extra vertical to match list-projects
      .list-caret {
        transform: translateY(-50%) rotate(90deg);
      }
      &.not-collapsed {
        .list-caret {
          transform: translateY(-50%) rotate(-90deg);
        }
      }
    }
  }
  .sublist-title.not-collapsed  {
    .list-caret {
      transform: translateY(-50%) rotate(90deg);
    }
  }
  .sublist-title.not-collapsed {
    .listitem--time {
      height: 0px;
    }
  }
  .accordion {
    hr { margin: 0.5rem 0; }
    &--actions {
      padding: 10px 7px;
      // padding-top: 5px;
      display: flex; 
      align-items: center;
    }
    .collapse {
      position: relative;
      .collapse {
        margin-left: 10px;
        border-left: 1px solid $colorBlue100;
        padding-right: 1px; // for selected shadow
        padding-top: 1px; // for selected shadow
        .listitem { border-radius: 0px $radiusSm $radiusSm 0px; }
      }
    }
  }
  .search {
    input:focus, input:hover {
      border-color: $colorBlue;
      outline: 0;
      box-shadow: none;
    }
    
  }
</style>
